import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../../environments/environment';
import { CompleteProfilePayload } from '../models/personal-info.model';
import { UserProfileResponse } from '@/app/dashboard/models/dashboard.model';
import { ApiResponse } from '@shared/models/api-response.models';

/**
 * All HTTP calls in this service return the standard
 * `ApiResponse<T>` envelope.
 */
@Injectable({
  providedIn: 'root',
})
export class PersonalInfoService {
  private readonly apiUrl = environment.userManagementApiUrl;

  constructor(private readonly http: HttpClient) {}

  completeProfile(
    userId: string,
    payload: CompleteProfilePayload
  ): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.post<ApiResponse<UserProfileResponse>>(
      `${this.apiUrl}/api/users/${userId}/complete-profile`,
      payload
    );
  }
}
